import { useFormikContext } from 'formik';
import { useDebounce } from '@scramble/hooks';
import { InvestorDecisionWidget } from '@/containers/InvestorDecisionWidget';

export function WithdrawDecisionWidget() {
  const { values } = useFormikContext();
  const numericAmount = Number(values.amount);
  const liveAmount = numericAmount > 0 ? numericAmount : undefined;
  const debouncedAmount = useDebounce(liveAmount, 500);
  return <InvestorDecisionWidget placement="withdraw" amount={debouncedAmount} />;
}